import React from 'react';
import PropTypes from 'prop-types';
import {
	List,
	Popup
} from 'semantic-ui-react';

import styles from './form.module.css';

const ValidationPopup = ( {
	context,
	errors,
	open
} ) => {
	const mapErrors = () => errors.map( ( error, i ) => {
		if ( error.error ) {
			return (
				<List.Item
					key={ i }
					className={ styles.validationItem }
				>
					<List.Icon
						bordered
						color="red"
						inverted
						name="exclamation"
						size="small"
					/>
					&nbsp;
					{ error.message }
				</List.Item>
			);
		}

		return null;
	} );

	return (
		<Popup
			className={ styles.validationPopup }
			context={ context
				? context
				: null
			}
			flowing
			inverted
			open={ open }
			position="top center"
		>
			<Popup.Content>
				<List>
					<List.Content>
						{ mapErrors() }
					</List.Content>
				</List>
			</Popup.Content>
		</Popup>
	);
};

ValidationPopup.propTypes = {
	context: PropTypes.object.isRequired,
	errors: PropTypes.arrayOf( PropTypes.shape( {
		error: PropTypes.bool,
		message: PropTypes.node
	} ) ),
	open: PropTypes.bool.isRequired
};

export default ValidationPopup;
